import { gql } from "generated-graphql";

export const ACQUIRE_CREDENTIAL_LOCK = gql(`
  mutation AcquireCredentialLock($input: AcquireCredentialLockInput!) {
    acquireCredentialLock(input: $input) {
      success
      message
      lockId
      credentialId
      lockedBy
      lockExpiresAt
      lockedUsername
      lockedState
      credential {
        id
        username
        password
        portalUrl
        tech
        type
        securityQuestions {
          question
          answer
        }
        verificationStatus
        lastVerificationCheckAt
        usesCombinedInvoicing
        usesRcoCredential
      }
    }
  }
`);

export const RELEASE_CREDENTIAL_LOCK = gql(`
  mutation ReleaseCredentialLock($lockId: ID!) {
    releaseCredentialLock(lockId: $lockId)
  }
`);
